@if (renderDescription) {
  <sidebar-title-description
    [description]="sidebarElement().guidelineAction.description"
    [showDescription]="sidebarElement().showDescription"
    [title]="sidebarElement().guidelineAction.title"
    (descriptionChange)="onDescriptionChangedEvent($event)"
    (showDescriptionChange)="onShowDescriptionChange($event)"
    (titleChange)="onTitleChanged($event)" />
}

<tt-divider class="tt-guideline-sidebar_divider" />

<tt-guideline-component-sidebar-basics
  [attachments]="sidebarElement().attachments"
  [links]="sidebarElement().links"
  [references]="sidebarElement().references"
  [resourceTags]="sidebarElement().resourceTags ?? []"
  (basicsChanged)="handleBasicsChanged($event)" />

<tt-divider class="tt-guideline-sidebar_divider" />

@if (hasColorPresets()) {
  <div class="tt-guideline-sidebar_color-preset">
    <span>{{ 'Color' | transloco }}:</span>
    <tt-customisable-flowchart-element
      [colorPresets]="colorPresets()"
      [flowchartNodeConfig]="flowchartNodeConfig()"
      (colorPresetChanged)="onColorPresetChanged($event)" />
  </div>
  <tt-divider class="tt-guideline-sidebar_divider" />
}

@if (!sidebarElement().guidelineCriteria && !showSearch) {
  <div class="tt-action-tab_actions">
    <button
      aria-label="Add finding button"
      class="action-tab__add"
      emphasis="minimal"
      ttButton
      variant="primary"
      (click)="enableSearch($event)">
      <mat-icon [icon]="'plus'" [iconSize]="14" />
      <span>{{ 'AddFinding' | transloco }}</span>
    </button>
  </div>
}
